// extracted by mini-css-extract-plugin
export default {"root":"ListingBadge_root__Q0eyk marketplaceTinyFontStyles"};